import { ProductDetail } from "../../Components";

export function ProductDetails() {
  return (
    <div>
      <ProductDetail />
    </div>
  );
}
